import { createAction } from 'lib/store-utils';

export const BOX_SHIFT_TIME_RANGE_INPUT_LEGEND_OPENED = createAction('Shift time range input legend / opened');
export const BOX_SHIFT_TIME_RANGE_INPUT_LEGEND_CLOSED = createAction('Shift time range input legend / closed');
